module.exports = __webpack_public_path__ + "media/images/home/8-4f46ea1e556ee6e3d03800e9d7d38b08.png";